
namespace Sintra {

	class WizardPathCollector {
		//private _pagesRegistry: Map<string, WizardPageData>;
		private _pagesRegistry: TypedValueObject<string, WizardPageData>;
		private _keysSequence: string[];
		//private _groupSequence: Set<string>;
		private _groupSequence: DistinctArray<string>;
		private _isRecursive = false;
		//private _groupsMap: Map<string, string>;
		private _groupsMap: TypedValueObject<string, string>;

		//constructor(pagesRegistry: Map<string, WizardPageData>, otherPathCollector: WizardPathCollector = null) {
		constructor(pagesRegistry: TypedValueObject<string, WizardPageData>, otherPathCollector: WizardPathCollector = null) {	

			this._keysSequence = [];
			//this._groupSequence = new Set();
			this._groupSequence = new DistinctArray();
			this._pagesRegistry = pagesRegistry;
			//this._groupsMap = new Map();
			this._groupsMap = {};

			if (otherPathCollector) {
				this._keysSequence.push(...otherPathCollector._keysSequence);
				// for (const item of otherPathCollector._groupSequence) {
				// 	this._groupSequence.add(item);
				// }
				otherPathCollector._groupSequence.forEach(element => {
					
				});
				// for (const item of otherPathCollector._groupsMap) {
				// 	this._groupsMap.set(item[0], item[1]);
				// }
				for (const k of Object.keys(otherPathCollector._groupsMap)) {
					this._groupsMap[k] = otherPathCollector._groupsMap[k];
				}
			}
		}

		append(pageKey: string, pageData: WizardPageData) {
			// if (!this._pagesRegistry.has(pageKey)){
			// 	this._pagesRegistry.set(pageKey, pageData);
			// }
			if (!(pageKey in this._pagesRegistry)){
				this._pagesRegistry[pageKey] = pageData;
			}
			if (this._keysSequence.indexOf(pageKey) < 0) {
				this._keysSequence.push(pageKey);
				this._groupSequence.add(pageData.groupName);

				// if (!this._groupsMap.has(pageData.groupName)) {
				// 	this._groupsMap.set(pageData.groupName, pageKey);
				// }
				if (!(pageData.groupName in this._groupsMap)){
					this._groupsMap[pageData.groupName] = pageKey;
				}
			}
			else {
				this._isRecursive = true;
				this._keysSequence.push(pageKey);
			}
		}

		getGroupSequence() {
			//return Array.from(this._groupSequence);
			this._groupSequence.toArray();
		}

		getGroupsMap() {
			//return Array.from(this._groupsMap);
			const result = [];
			for (const k of Object.keys(this._groupsMap)) {
				const mapEntry: MapEntry<string, string> = [
					k,
					this._groupsMap[k]
				];
				result.push(mapEntry);
			}
			return result;
		}
	}

	export class WizardPathResolver {

		private _wizardData: WizardData;
		// private _globalPages: Map<string, WizardPageData>;
		// private _globalTargetsList:Set<Iterable<string>>;
		// private _globalPathCollectors: Set<WizardPathCollector>;
		private _globalPages: TypedValueObject<string, WizardPageData>;
		private _globalTargetsList: DistinctArray<DistinctArray<string>>;
		private _globalPathCollectors: DistinctArray<WizardPathCollector>;

		constructor(wizardData: WizardData) {
			this._wizardData = wizardData;
			// this._globalPages = new Map<string, WizardPageData>();
			// this._globalTargetsList = new Set<Iterable<string>>();
			// this._globalPathCollectors = new Set<WizardPathCollector>();
			this._globalPages = {};
			this._globalTargetsList = new DistinctArray<DistinctArray<string>>();
			this._globalPathCollectors = new DistinctArray<WizardPathCollector>();
		}

		private _getNavigationButtonTargets(navigationButtons: WizardNavButtonData[]) {
			//const result = new Set<string>();
			const result = new DistinctArray<string>();
			for(const navBtn of navigationButtons) {
				if (navBtn.target && typeof navBtn.target === "string" && navBtn.target.length > 0) {
					result.add(navBtn.target);
				}
			}
			return result;
		}

		private _getNavigationButtonCompletes(navigationButtons: WizardNavButtonData[]) {
			//const result = new Set<WizardNavButtonData>();
			const result = new DistinctArray<WizardNavButtonData>();
			for(const navBtn of navigationButtons) {
				if (!!navBtn.complete) {
					result.add(navBtn);
				}
			}
			return result;
		}

		//private _readPage(pageKey: string, currentNavTargets: Set<string>, currentPathCollector: WizardPathCollector) {
		private _readPage(pageKey: string, currentNavTargets: DistinctArray<string>, currentPathCollector: WizardPathCollector) {

			const pageData = this._wizardData.pages[pageKey];
			if (pageData) {
	
				if (currentNavTargets.has(pageKey)) {
					//debugger;
					return;
				}
				currentNavTargets.add(pageKey);
	
				currentPathCollector.append(pageKey, pageData);
	
				if (pageData.navigationButtons && pageData.navigationButtons.length > 0) {
					const navCompletes = this._getNavigationButtonCompletes(pageData.navigationButtons);
					// for(const navBtn of navCompletes) {
					// 	this._globalTargetsList.add(currentNavTargets);
					// 	this._globalPathCollectors.add(currentPathCollector);
					// }
					navCompletes.forEach(navBtn => {
						this._globalTargetsList.add(currentNavTargets);
						this._globalPathCollectors.add(currentPathCollector);
					});
					const navTargets = this._getNavigationButtonTargets(pageData.navigationButtons);
					// for(const target of navTargets) {
					// 	const childNavTargets = new Set(currentNavTargets);
					// 	const childPathCollector = new WizardPathCollector(this._globalPages, currentPathCollector);
					// 	this._readPage(target, childNavTargets, childPathCollector);
					// }
					navTargets.forEach(target => {
						const childNavTargets = new DistinctArray<string>(currentNavTargets.toArray());
						const childPathCollector = new WizardPathCollector(this._globalPages, currentPathCollector);
						this._readPage(target, childNavTargets, childPathCollector);
					});
				}
			}
		}


		public resolveGroupNamePaths(): Array<Array<MapEntry<string, string>>> {
			//debugger;
			// TODO completare
			const currentKey = this._wizardData.startPage;
			//const navTargets = new Set<string>();
			const navTargets = new DistinctArray<string>();
			const pathCollector = new WizardPathCollector(this._globalPages);
			this._readPage(currentKey, navTargets, pathCollector);

			// console.dir(this._globalTargetsList);
			// console.dir(Array.from(this._globalPathCollectors).map(x => x.getGroupSequence().join(", ")));

			//const resultPathCollectors = new Map<string, Array<MapEntry<string, string>>>();
			const resultPathCollectors: TypedValueObject<string, Array<MapEntry<string, string>>> = {}; 
			// for (const pathCollector of this._globalPathCollectors) {
			// 	const groups = pathCollector.getGroupsMap();
			// 	const key = groups.map(x => x[0]).join(", ");
			// 	resultPathCollectors.set(key, groups);
			// }
			this._globalPathCollectors.forEach(pathCollector => {
				const groups = pathCollector.getGroupsMap();
				const key = groups.map(x => x[0]).join(", ");
				resultPathCollectors[key] = groups;
			});

			const resultValues = Object.keys(resultPathCollectors).map(k => resultPathCollectors[k]);
			//console.log(resultPathCollectors.values());
			console.log(resultValues);
			//return Array.from(resultPathCollectors.values());
			return resultValues;
		}
	}
}